app.controller('CommonDatepickerController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.openDatepicker = function ($event) {

        const params = {
            format: 'yyyy-mm-dd',
            editable: true // prevents a bug in pickadate where the datepicker will reopen when you switch tabs
        }

        let disable = [];

        if ($scope.days_of_week_disabled) {
            const daysOfWeekDisabled = $scope.days_of_week_disabled.split(",");
            for (let i = 0; i < daysOfWeekDisabled.length; i++) {
                disable.push(parseInt(daysOfWeekDisabled[i]) + 1);
            }
        }

        if ($scope.getDisabledDates) {
            disable = disable.concat($scope.getDisabledDates());
        }
        if (disable.length) {
            params.disable = disable;
        }
        if ($scope.determineStartDate) {
            params.min = $scope.determineStartDate();
        } else if ($scope.date_from_today) {
            params.min = new Date();
        } else if ($scope.date_until_today) {
            params.max = new Date();
        }

        const $datepicker = $($event.target)
        let datepickerID = $datepicker.attr("id");
        if (!datepickerID) {
            datepickerID = 'P' + Math.abs(~~(Math.random() * new Date()));
            $datepicker.attr("id", datepickerID)
        }

        $datepicker.pickadate(params);

        $datepicker.off('focus.' + datepickerID) // prevents a bug in pickadate where the datepicker will reopen when you switch tabs
        $datepicker.attr('readonly', true);

        const $pickerHolder = $datepicker.next().find(".picker__holder");
        $pickerHolder.off('focus.toOpen'); // prevents a bug in pickadate will close when the mouse button is held very briefly
    }

}]);